import {load} from 'recaptcha-v3'

export default async function loadRecaptcha() {
    return await load('6Lc-qpYaAAAAAGUo0sKyKT0YArxruEQrSzpnMFHQ')
}
